// Foundational, dependency-free string primitives. Kept free of R/S (and the
// `core/helpers` barrel) so this module stays cycle-safe once it is re-exported
// from `core/helpers/index.ts`.

import { InputMask } from './types'

/** Removes every non-digit character. */
export const digitsOnly = (input: string): string => (input ?? '').replace(/\D/g, '')

/** Truncates a string to at most `maxLength` characters. */
export const clampLength = (value: string, maxLength: number): string => value.slice(0, maxLength)

/**
 * Builds a `sanitize` function that keeps digits only and caps the raw length.
 * The common building block for digit-based masks.
 */
export const sanitizeDigits =
  (maxLength: number) =>
  (input: string): string =>
    clampLength(digitsOnly(input), maxLength)

// Mirrors TextInput's historical `format='digits'` behavior byte-for-byte:
// digit-only identifier strings (card number, CVC, ZIP). Unlike `integer`
// there is NO blur normalization, so leading zeros and arbitrarily long
// values are preserved verbatim. No default placeholder.
const digitsPattern = /^\d*$/

export const digitsFormat: InputMask = {
  sanitize: (input) => (digitsPattern.test(input) ? input : null),
  format: (raw) => raw,
}
